import ColorsStyles from '@Styles/colors.scss';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RemoveIcon from '@mui/icons-material/Remove';
import {
    Accordion,
    AccordionDetails,
    AccordionProps,
    AccordionSummary,
    AccordionSummaryProps,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import _isNil from 'lodash/isNil';
import React from 'react';
import Styles from '../EntityDrawer.scss';

const AttributesAccordion = styled((props: AccordionProps) => (
    <Accordion {...props} />
))(({ theme }) => ({
    margin: '5px 0 5px 10px',
    boxShadow:
        '0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12)',
    '&.Mui-expanded': {
        margin: '5px 0 5px 10px',
    },
    '&.Mui-expanded:first-of-type': {
        marginTop: '5px',
    },
}));

const AttributesAccordionSummary = styled((props: AccordionSummaryProps) => (
    <AccordionSummary
        expandIcon={
            <ExpandMoreIcon sx={{ fontSize: '0.5rem', color: '#1A1E2C' }} />
        }
        {...props}
    />
))(({ theme }) => ({
    fontFamily: 'Barlow Condensed',
    backgroundColor: '#C9CDD2',
    fontWeight: '600',
    minHeight: '19px',
    maxHeight: '19px',
    alignItems: 'center',
    fontSize: '12px',
    lineHeight: '19px',
    letterSpacing: '0.02em',
    margin: 0,
    paddingLeft: '8px',
    color: ColorsStyles.ikeGradient1,
    userSelect: 'auto',
    flexDirection: 'row-reverse',
    gap: '8px',
    '&:hover': {
        backgroundColor: '#E0E3E7',
        borderLeft: '2px solid #1FA163',
    },
    '&.MuiAccordionSummary-expandIconWrapper': {
        cursor: 'pointer',
    },

    root: {
        '&.Mui-expanded': {
            margin: '0 !important',
            minHeight: '19px !important',
            maxHeight: '19px',
        },
    },
}));

interface INestedAccordionProps {
    title: string;
    data: any;
    defaultClosed?: boolean;
    // isOpen: boolean;
    // onClick: () => void;
}

const NestedAccordion = (props: INestedAccordionProps) => {
    const { title, data, defaultClosed } = props;

    return (
        <AttributesAccordion
            defaultExpanded={defaultClosed ? false : true}
            square={true}
            disableGutters
            sx={{
                '&.Mui-expanded': {
                    minHeight: '19px !important',
                },
                '::before': {
                    display: 'none',
                },
                overflowX: 'hidden',
            }}
        >
            <AttributesAccordionSummary>
                <div className={Styles.attributeAccordionTitleContainer}>
                    {/* <div className={Styles.attributeRowDash}>
            <span>{'-'}</span>
          </div> */}
                    <span>{title}</span>
                </div>
            </AttributesAccordionSummary>
            <AccordionDetails>{data}</AccordionDetails>
        </AttributesAccordion>
    );
};

export default NestedAccordion;
